/**
 * Client-side mirror of the backend's uploader-window derivation
 * (wedding date + package months, calendar-clamped). Display only —
 * the server recomputes authoritatively on every save.
 */
export function uploadsOpenUntil(
  weddingDate: string,
  months: number | null,
): Date {
  const [y = 0, m = 1, d = 1] = weddingDate.split("-").map(Number);
  const totalMonths = m - 1 + (months ?? 1);
  const targetYear = y + Math.floor(totalMonths / 12);
  const monthIndex = ((totalMonths % 12) + 12) % 12;
  const daysInTarget = new Date(targetYear, monthIndex + 1, 0).getDate();
  return new Date(targetYear, monthIndex, Math.min(d, daysInTarget));
}
